import { AdressDataModel } from '@/models/AdressResulModel';
import { AddressResult } from '@/models/AdressResult';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseRepoService } from '../BaseRepo';

@Injectable({
  providedIn: 'root'
})
export class ApiAdresseRepo extends BaseRepoService {
  readonly SEARCH = '/search';

  constructor(protected http: HttpClient) {
    super(http);
    this.BASE_PATH_URL = environment.core.apiAdresse;
  }

  search(search: string): Observable<AdressDataModel[]> {
    let params = new HttpParams();
    params = params.append('q', search);
    const options = this.getHttpOptions(params);
    return this.get<AddressResult>(this.SEARCH, options).pipe(
      map((o) => o.features.map((a) => new AdressDataModel(a)))
    );
  }
}
